import React from 'react';
import { Globe, Database } from 'lucide-react';

const SiteSelector = ({ 
  sites, 
  currentSite, 
  onSiteChange, 
  sitesLoading,
  sitesError 
}) => {
  
  if (sitesLoading) {
    return (
      <div className="flex items-center gap-2">
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
        <span className="text-sm text-gray-600">Loading sites...</span>
      </div>
    );
  }

  if (sitesError) {
    return (
      <div className="flex items-center gap-2">
        <div className="w-2 h-2 bg-red-500 rounded-full"></div>
        <span className="text-sm text-red-600">Error loading sites: {String(sitesError)}</span>
      </div>
    );
  }

  if (!Array.isArray(sites) || sites.length === 0) {
    return (
      <div className="flex items-center gap-2">
        <Globe className="w-5 h-5 text-gray-400" />
        <span className="text-sm text-gray-500">No sites available</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center gap-2">
        <Globe className="w-5 h-5 text-blue-600" />
        <span className="text-sm font-medium text-gray-700">Site:</span>
      </div>
      <select
        value={currentSite || ''}
        onChange={(e) => onSiteChange(e.target.value)}
        className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      >
        {!currentSite && (
          <option value="" disabled>Select a site...</option>
        )}
        {sites.map((site) => {
          // Sites should be objects with id, name, domain, status
          if (site && typeof site === 'object' && site.id && site.name) {
            return (
              <option key={String(site.id)} value={String(site.id)}>
                {String(site.name)} ({String(site.domain || site.id)})
              </option>
            );
          } else {
            console.error('Invalid site object:', site);
            return null;
          }
        })}
      </select>
      <div className="flex items-center gap-2 ml-auto">
        <div className="w-2 h-2 bg-green-500 rounded-full"></div>
        <span className="text-sm text-gray-600">Synced with Cloudflare</span>
      </div>
    </div>
  );
};

export default SiteSelector;